import React from 'react'
import PropTypes from 'prop-types'
import { isNil, noop } from 'lodash'

import { PHONE_PLACEHOLDER } from 'utils/constants/defaultValues'
import { formatPhone } from 'utils/formatters/phone'
import { FormBlock } from 'components/formBlock/FormBlock'
import { PhoneInput } from 'components/inputNumberFormat/phoneInput/PhoneInput'

export const FormInputPhone = ({
  allowEmptyFormatting,
  className,
  field,
  format,
  handleFieldChange,
  handleIsAllowed,
  isDisabled,
  isReadonly,
  isRequired,
  mask,
  onChange,
  placeholder = PHONE_PLACEHOLDER,
  size,
  showErrorText,
  title,
}) => {
  const handleChange = onChange ? onChange : handleFieldChange ? handleFieldChange(field.name) : noop
  const isRequiredField = isNil(isRequired) ? field.isRequired : isRequired

  return (
    <FormBlock
      title={title}
      readonlyView={formatPhone(field.value)}
      isReadonly={!!isReadonly}
      isRequired={!!isRequiredField}
      className={className}>
      <PhoneInput
        allowEmptyFormatting={allowEmptyFormatting}
        error={field.error}
        format={format}
        handleIsAllowed={handleIsAllowed}
        isDisabled={isDisabled}
        mask={mask}
        onChange={handleChange}
        placeholder={placeholder}
        size={size}
        showErrorText={showErrorText}
        value={field.value}
      />
    </FormBlock>
  )
}

FormInputPhone.propTypes = {
  allowEmptyFormatting: PropTypes.bool,
  className: PropTypes.string,
  field: PropTypes.object.isRequired,
  format: PropTypes.string,
  handleFieldChange: PropTypes.func,
  handleIsAllowed: PropTypes.func,
  isDisabled: PropTypes.bool,
  isReadonly: PropTypes.bool,
  isRequired: PropTypes.bool,
  mask: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['regular', 'small']),
  showErrorText: PropTypes.bool,
  title: PropTypes.string,
}
